import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ElementRef,
  ViewChild,
  AfterViewInit
} from '@angular/core';
import * as Highcharts from 'highcharts';
import { HighchartsColorCodes } from '@nrwl/common-lib';
import { uniqueId } from 'lodash';

@Component({
  selector: 'nrwl-performance-stream-comparisons',
  templateUrl: './performance-stream-comparisons.component.html',
  styleUrls: ['./performance-stream-comparisons.component.css']
})
export class PerformanceStreamComparisonsComponent implements OnChanges, AfterViewInit {
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  @Input() chartType: string = 'IR'; // or 'FL', 'FD', etc.
  @Input() categories: string[] = [];
  @Input() seriesData: { name: string; data: number[] }[] = [];
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  @Input() chartId: string = '';

  @ViewChild('chartContainer', { static: false }) chartContainer!: ElementRef;

  chartPerfId: string;
  chartColorCodes = [];

  constructor() {
    this.chartPerfId = uniqueId('perf-stream-');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.categories || changes.seriesData) {
      this.initializeChart();
    }
  }

  ngAfterViewInit(): void {
    this.initializeChart();
  }

  initializeChart(): void {
    this.chartColorCodes = [
      HighchartsColorCodes.VIOLET,
      HighchartsColorCodes.AQUA,
      HighchartsColorCodes.ATLANTIS,
      HighchartsColorCodes.CEREISE,
      HighchartsColorCodes.TAPA,
      HighchartsColorCodes.LAKE,
      HighchartsColorCodes.ELECTRIC_VIOLET,
      HighchartsColorCodes.EARLY_GREEN,
      HighchartsColorCodes.DODGER_BLUE,
      HighchartsColorCodes.OCEAN_BLUE
    ];
    if (!this.chartContainer) {
      return; // Ensure the chart container is available
    }

    const yAxisConfig = {
      title: {
        text:
          this.chartType === 'IR' || this.chartType === 'ULR'
            ? 'Mbps'
            : this.chartType === 'Loss'
            ? 'Percentage'
            : this.chartType === 'FD Distribution'
            ? 'Frame Count'
            : 'ms'
      },
      min: 0, // default minimum value
      max: undefined // default maximum value
    };

    Highcharts.chart(this.chartPerfId, {
      chart: {
        type: 'column',
        style: {
          fontFamily: 'Roboto,Helvetica Neue,sans-serif'
        }
      },
      title: {
        text: this.chartType,
        style: {
          fontSize: '14px'
        }
      },
      credits: { enabled: false },
      colors: this.chartColorCodes,
      xAxis: {
        categories: this.categories
      },
      yAxis: yAxisConfig,
      plotOptions: {
        column: {
          borderWidth: 1, // Ensures a visible outline
          minPointLength: 3 // Forces a minimum height for zero values
        }
      },
      series: this.seriesData.map((data, index) => ({
        type: 'column',
        name: data.name,
        data: data.data,
        color: this.chartColorCodes[index],
        states: {
          hover: {
            brightness: 0.2 // Ensure hover effect still works
          }
        }
      }))
    });
  }
}
